<section class="block_registration" alock="true">
    <div>
        <h1>ВХОД</h1>
        <form [formGroup]="loginForm" (ngSubmit)="onSubmit()">
        <div class="row">
            <div class="col-5">
                <p class="desc_p">E-mail:</p>
            </div>
            <div class="col-4 input_necessary">
                <input type="text" name="user_name" formControlName="email">
            </div>
        </div>

        <div class="row">
            <div class="col-5">
                <p class="desc_p">Пароль:</p>
            </div>
            <div class="col-4">
                <div class="password input_necessary">
                    <input type="password" id="password-input" name="password" formControlName="password" autocomplete="on">
                    <span class="password-control" id="password-control" (click)="show_hide_password()"></span>
                </div>
            </div>
        </div>

        <p class="polit_block">
            <button type="submit" [disabled]="!loginForm.valid" class="add_button">Войти</button> 
            <a class="registration_button" routerLink="/auth/registration"> Зарегистрироваться </a>
            <a class="registration_button" routerLink="/auth/reset"> Сбросить пароль </a>
        </p>
        </form>
    </div>
</section>

<div class="popap_rega dark_block"  style="display: none;">
<div>
    <p class="close_btn" ><img src="/newpion/static/pionfront/assets/img/close_btn.png"></p>
    <div class="text_block">
        <img src="/newpion/static/pionfront/assets/img/info.png">
        <p>Вы не завершили регистрацию, введенные данные будут утеряны!</p>
        <p id="access_link" ><a href="">Всё равно перейти</a></p>
    </div>
</div>
</div>